import EasyStep from "./easy-step.js";
module.exports = EasyStep;


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/